import type { TerminalVersionDto } from "../../types/TerminalVersionDto";
import type { TerminalVersionEntity } from "../../types/TerminalVersionEntity";

export const TerminalVersionDtoToEntity = ({ ...rest }: Readonly<TerminalVersionDto>): TerminalVersionEntity => {
    return { ...rest };
};
